<template>
  <div class="col-12 container">
    <b-card class="px-0">
      <div slot="header">
        <b-row align-v="center">
          <b-col cols="12" md="6">
            <b v-text="`${$lang.ticketLang.ticket_page.edit_ticket} `" />
            <b-badge
              variant="primary"
              class="fontSize-15"
              pill
              v-text="(item && item.details && item.details.length) || 0"
            />
          </b-col>
          <b-col cols="12" md="6" class="ticket_code"
            ><b
              v-text="
                `${$lang.ticketLang.ticket_page.ticket_number}: ${
                  (item && item.ticket_code) || ''
                }`
              "
          /></b-col>
        </b-row>
      </div>
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <ChatBox
        v-else
        ref="chat"
        accessLevel="admin"
        :btnloading="btnLoading"
        :item="item"
        @submit="save"
        @changeTicketUnit="changeTicketUnit"
        @postSms="postSms"
        @closePage="handleBack"
        @responseCode="setResponseCode"
      />
    </b-card>
  </div>
</template>

<script>
import ChatBox from "../components/chatBox";
import { pathOr } from "ramda";

export default {
  components: {
    ChatBox,
  },
  data() {
    return {
      code: this.$route.params.code,
      item: null,
      isLoading: false,
      btnLoading: false,
      attachmentId: null,
      responseCode: [],
    };
  },
  inject: [
    "allticketRepository",
    "ticketRepository",
    "ticketAnswerRepository",
    "allTicketUnitRepository",
    "allTicketSmsRepository",
    "attachmentTempFinalRepository",
  ],
  methods: {
    pathOr,
    async finalSave() {
      try {
        if (!this.responseCode.length) {
          return false;
        }
        let payload = {
          data: [],
        };
        for (const item of this.responseCode) {
          const resize_avatar = !!(
            item.type.match("image") && this.keyServies === "person"
          );

          payload.data.push({
            code: item.code,
            resize_avatar: resize_avatar,
            attachment_type_id: 22,
            attachment_type_name: "attachment_type_ticket",
          });
        }
        let actionResource = "ticket_detail";
        let actionkey = this.attachmentId;
        const result = await this.attachmentTempFinalRepository.create(
          payload,
          actionResource,
          actionkey
        );
        this.$refs.chat.$refs.attachFile.fileUpload = [];
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
        this.responseCode = [];
      }
    },
    setResponseCode(code) {
      this.responseCode = code;
    },
    async postSms(payload) {
      this.btnLoading = true;
      try {
        const response = await this.allTicketSmsRepository.create(
          this.code,
          payload
        );
        let { data } = response.data;
        this.attachmentId = data.id;
        if (this.attachmentId && this.responseCode.length > 0) {
          await this.finalSave();
        }
        await this.fetchData();
        let objDiv = this.$refs.chat.$refs.chatBox;
        objDiv.scrollTop = objDiv.scrollHeight;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.btnLoading = false;
      }
    },
    async save(payload) {
      this.btnLoading = true;
      try {
        const response = await this.ticketAnswerRepository.edit(
          this.code,
          payload
        );
        this.attachmentId = pathOr(null, ["data", "data", "id"], response);
        if (this.attachmentId && this.responseCode.length) {
          await this.finalSave();
        }
        await this.fetchData();
        let objDiv = this.$refs.chat.$refs.chatBox;
        objDiv.scrollTop = objDiv.scrollHeight;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.btnLoading = false;
      }
    },
    async changeTicketUnit(payload) {
      this.$refs.chat.loading = true;
      try {
        const response = await this.allTicketUnitRepository.partial_edit(
          this.code,
          payload
        );
        this.$notify.success(response.data.message);
        this.$refs.chat.loading = false;
        this.handleBack();
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fetchData() {
      this.isLoading = true;
      try {
        const response = await this.allticketRepository.find(this.code);
        this.item = response.data.data;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleBack() {
      window.history.length > 1 ? this.$router.go(-1) : window.close();
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>

<style>
@media (max-width: 575.98px) {
  .text_sm_right {
    text-align: right !important;
  }
}

.ticket_code {
  text-align: left;
  margin: 10px 0;
}

@media (max-width: 767px) {
  .ticket_code {
    text-align: right;
  }
}
</style>
